module.exports = __webpack_public_path__ + "static/media/square2.f98ba42b.jpg";